<app-ge-ex-navbar></app-ge-ex-navbar>
  <router-outlet></router-outlet>
<app-ge-ex-footer></app-ge-ex-footer>
